import { Row, Space, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { columns } from './TicketPay.config'
import { payService } from "api";
import { useAppSelector } from 'redux/hooks';
import Notification from "components/common/notification/notification";

const TicketPay = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const maBenhNhan = useAppSelector((state) => state.reduxCommon.maBenhNhan)

  const handlePaginationChangeList = (page) => {
    setCurrentPage(page);
  };

  const paginationConfig = {
    current: currentPage, 
    total: totalPage, 
    onChange: handlePaginationChangeList,
  };
  
  useEffect(()=>{
    getData();
  },[maBenhNhan]);

  const getData = async () => {
    try {
      let response = await payService
        .getDataPatientCard(maBenhNhan)
        .then((res) => {
          // console.log('data the kham', res);
          setData(res.data.data);
        });
    } catch (err) {
      ;
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách thẻ khám"
      );
    }
  }

  return (
    <div>
      <Space direction="vertical" size={"middle"} style={{ width: "100%" }}>
        <Table
          bordered
          dataSource={data}
          columns={columns}
          pagination={paginationConfig}>
        </Table>
      </Space>
    </div>
  )
}

export default TicketPay